import { Component } from '@angular/core';
import { IonCard, IonCardContent, IonCol, IonGrid, IonRow, IonSkeletonText } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-skeleton-card-inprogress',
  templateUrl: './skeleton-card-inprogress.component.html',
  styleUrls: ['./skeleton-card-inprogress.component.scss'],
  imports: [IonCardContent, IonRow, IonGrid, IonCol, IonCard, IonSkeletonText],
})
export class SkeletonCardInprogressComponent {
  // constructor() {}
}
